import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router-dom";
import { Button } from "@components/atoms/buttons/button/button";
import { Route } from "@src/routes/routes";
import styles from "./login.module.scss";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { VersionStringInfo } from "@src/components/atoms/version-string-info/version-string-info";
import { i18n } from "@src/i18n/i18n";

const LoginActions = () => {
  const auth = useAuth();
  const location = useLocation();
  //TODO: implement when LanguageProvider is ready also for Login and Logout Components
  /* const i18n = useI18N(); */

  const texts = {
    loginRequiredTextZitadelMessage: i18n(
      "pages.login.loginRequiredTextZitadelMessage",
    ),
    signingOutMessage: i18n("pages.login.signingOutMessage"),
    redirectingToLoginPage: i18n("pages.login.redirectingToLoginPage"),
  };

  const loginRequiredTextKeycloak = "login_required";

  const loginRequiredTextZitadel = texts.loginRequiredTextZitadelMessage;

  useEffect(() => {
    auth.signinSilent();
  }, []);

  switch (auth.activeNavigator) {
    case "signinSilent":
      return null;
    case "signoutRedirect":
      return <div>{texts.signingOutMessage}</div>;
  }

  if (auth.isLoading) {
    return (
      <div
        style={{
          textAlign: "center",
        }}
      >
        {texts.redirectingToLoginPage}
      </div>
    );
  }

  if (
    auth.error &&
    auth.error.message !== loginRequiredTextKeycloak &&
    auth.error.message !== loginRequiredTextZitadel
  ) {
    console.log("auth.error", auth, auth.error);
    return <div>{texts.loginRequiredTextZitadelMessage}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <Navigate
        to={Route.THINGS_OS_HOMEPAGE}
        state={{ from: location }}
        replace
      />
    );
  }

  return (
    <Button
      style={{
        margin: "auto",
      }}
      fun={() => void auth.signinRedirect()}
      text={"Log In"}
    />
  );
};

export const Login = () => {
  return (
    <div className={styles["login-container"]}>
      <div className={styles["login-actions-container"]}>
        <h2 className={styles["login-heading"]}>Tomorrow Things</h2>
        <LoginActions />
      </div>

      <Spacer16 />
      <Spacer16>
        <div className={styles["login-version"]}>
          <VersionStringInfo tooltipPosition={"bottom"} />
        </div>
      </Spacer16>
    </div>
  );
};
